import { ReactElement } from "react";
import { SurveyStatus } from "../../../redux/survey/survey.types";
import { ReactComponent as Share } from '../../../assets/icons/share.svg';
import { ReactComponent as Loading } from '../../../assets/icons/loading.svg';
import useShareSurvey from "../../../hooks/useShareSurvey";

export interface SurveyShareButtonProps {
  readonly surveyId?: string;
  readonly surveyStatus?: SurveyStatus;
}

const SurveyShareButton = ({ surveyStatus, surveyId }: SurveyShareButtonProps): ReactElement | null => {
  const { handleShare, isLoading, canShare } = useShareSurvey({ surveyId, surveyStatus });

  if (!canShare) {
    return null;
  }

  return (
    <button
      onClick={handleShare}
      className="sm-max:hidden ml-2 flex items-center rounded-3xl bg-white lg-max:p-2 px-6 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-501"
      title="This button copies a publicly shareable link to this survey’s results"
    >
      <div className="mr-2 lg-max:m-0">
        {isLoading ? <Loading className="animate-spin stroke-black" /> : <Share />}
      </div>
      <span className="lg-max:hidden">
        Share survey
      </span>
    </button>
  );
};

export default SurveyShareButton;
